<div class="modal">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h2>{{ personToEdit == null? ('PEOPLE.ADD_TITLE' | translate) : ('PEOPLE.EDIT_TITLE' | translate) }}</h2>
        <button type="button" class="btn-close"  aria-label="Close" (click)="onClose()"></button>
      </div>
      @if (formReady) {
<form  [formGroup]="personForm" (ngSubmit)="onSubmit()">
        <div class="modal-body">
          <div class="row align-items-center">
            <div class="col-12">
              @if (personForm.get('firstName')?.hasError('required') && personForm.get('firstName')?.touched) {
<div class="alert alert-danger small mt-1">
                  {{ 'PEOPLE.ERRORS.FIRSTNAME_REQUIRED' | translate }}
              </div>
}
              @if (personForm.get('lastName')?.hasError('required') && personForm.get('lastName')?.touched) {
<div class="alert alert-danger small mt-1">
                  {{ 'PEOPLE.ERRORS.LASTNAME_REQUIRED' | translate }}
              </div>
}
            </div>
            <div class="col">
              <div class="form-floating mb-3">
                <input type="text" class="form-control" id="firstName" formControlName="firstName" placeholder="{{ 'PEOPLE.FIRST_NAME' | translate }}"/>
                <label for="firstName">{{ 'PEOPLE.FIRST_NAME' | translate }}</label>
              </div>
            </div>
            <div class="col">
              <div class="form-floating mb-3">
                <input type="text" class="form-control" id="lastName" formControlName="lastName" placeholder="{{ 'PEOPLE.LAST_NAME' | translate }}" />
                <label for="lastName">{{ 'PEOPLE.LAST_NAME' | translate }}</label>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              @if (personForm.hasError('invalidDateRange') && personForm.touched) {
<div class="alert alert-danger small mt-1" >
                {{ 'PEOPLE.ERRORS.INVALID_DATE_RANGE' | translate }}
              </div>
}
            </div>
            <div class="col-auto">
                <label class="form-label mb-1" for="hiring_date">{{ 'PEOPLE.HIRING_DATE' | translate }}</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-calendar"></i></span>
                  <input class="form-control" id="hiring_date" type="date" formControlName="hiring_date" />
                </div>
            </div>
            <div class="col-auto">
                <label class="form-label mb-1" for="exit_date">{{ 'PEOPLE.EXIT_DATE' | translate }}</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-calendar"></i></span>
                  <input class="form-control" id="exit_date" type="date" formControlName="exit_date" />
                  <span class="input-group-text" (click)="clearExitDate()"><i class="bi bi-x-circle"></i></span>
                </div>
            </div>
          </div>

          <div class="row mt-3 mb-3">
            <div class="col-12">
              <div class="d-inline-flex align-items-center">
                <label class="form-label mb-0 me-3" for="is_contractor">{{ 'PEOPLE.IS_CONTRACTOR' | translate }}</label> 
                <div class="form-check form-switch mb-0"> 
                  <input class="form-check-input" type="checkbox" id="is_contractor" formControlName="is_contractor" role="switch" />
                </div>
              </div>
            </div>
          </div>
          @if (personToEdit!=null ) {
<div class="row mt-3 mb-3">
            <div class="col-12">
              <h4>{{ 'PEOPLE.AVATAR' | translate }}</h4>
            </div>
            <div class="col-12 d-flex align-items-center">
              <p-fileUpload
                #fu
                mode="basic"
                [chooseLabel]="(personToEdit && personToEdit.avatar ? 'COMMON.UPDATE' : 'COMMON.CHOOSE') | translate"
                chooseIcon="pi pi-upload"
                name="avatar"
                [url]="apiUrl + '/peoples/' + (personToEdit ? personToEdit.id : '0') + '/avatar'"
                [auto]="true"
                accept="image/*"
                maxFileSize="1000000"
                (onSelect)="onAvatarSelect($event)"
                (onUpload)="onAvatarUpload($event)"
                (onError)="onAvatarUploadError($event)"
                class="me-3"
              />

              <div class="avatar-preview-container">
                @if (personForm.get('avatar')?.value) {
<img alt="Avatar" class="avatar-preview" [src]="personForm.get('avatar')?.value">
}
                @if ( !personForm.get('avatar')?.value) {
                  <span class="text-muted">{{ 'PEOPLE.NO_AVATAR' | translate }}</span>
                }
              </div>
            </div>
          </div>
}
          <div class="row mb-3">
            <div class="col">
                <label class="form-label mb-1" for="role">{{ 'PEOPLE.ROLE' | translate }}</label>
                <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-person-badge"></i></span>
                    <select class="form-select" id="role" formControlName="role">
                        <option value="" disabled selected>{{ 'PEOPLE.SELECT_ROLE' | translate }}</option>
                        @for (role of roles; track roleTrackBy($index, role)) {
<option [value]="role.id">{{ role.name }}</option>
}
                    </select>
                </div>
            </div>
          </div>

          <div class="mb-3">
            <h3>{{ 'PEOPLE.SKILLS' | translate }}</h3>
            <div class="d-flex flex-wrap gap-2"> 
              @for (skill of skills$ | async; track skillTrackBy($index, skill)) {

                <input type="checkbox"
                      class="btn-check"
                      id="skill-{{ skill.id }}"
                      [formControlName]="'skill_' + skill.id"
                      autocomplete="off">
                <label class="btn btn-outline-secondary rounded-pill py-2 px-3" for="skill-{{ skill.id }}">
                  {{ skill.name }}
                </label>
              
}
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-primary" type="submit" [disabled]="!personForm.valid">{{ personToEdit ? ('PEOPLE.SAVE_CHANGES' | translate) : ('PEOPLE.ADD_PERSON' | translate) }}</button>
          <button class="btn btn-secondary" type="button" (click)="onClose()">{{ 'COMMON.CANCEL' | translate }}</button>
        </div>
      </form>
}
    </div>
  </div>
</div>